import React from 'react';

interface DialSegmentsProps {
  ctx: CanvasRenderingContext2D;
  centerX: number;
  centerY: number;
  radius: number;
  rotation: number;
}

export const drawDialSegments = ({
  ctx,
  centerX,
  centerY,
  radius,
  rotation
}: DialSegmentsProps) => {
  // Draw rotating outer segments
  for (let i = 0; i < 3; i++) {
    const segmentAngle = rotation + (Math.PI * 2 * i) / 3;
    const arcLength = Math.PI / 8;
    
    ctx.beginPath();
    ctx.arc(
      centerX,
      centerY,
      radius + 15,
      segmentAngle,
      segmentAngle + arcLength
    );
    
    const gradient = ctx.createLinearGradient(
      centerX + Math.cos(segmentAngle) * radius,
      centerY + Math.sin(segmentAngle) * radius,
      centerX + Math.cos(segmentAngle + arcLength) * radius,
      centerY + Math.sin(segmentAngle + arcLength) * radius
    );
    gradient.addColorStop(0, 'rgba(0, 255, 148, 0.8)');
    gradient.addColorStop(1, 'rgba(0, 102, 255, 0.8)');
    
    ctx.strokeStyle = gradient;
    ctx.lineWidth = 4;
    ctx.stroke();
  }

  // Draw inner accent lines
  for (let i = 0; i < 12; i++) {
    const angle = (Math.PI * 2 * i) / 12 + rotation;
    const innerRadius = radius - 30;
    const outerRadius = radius - 20;

    ctx.beginPath();
    ctx.moveTo(
      centerX + innerRadius * Math.cos(angle),
      centerY + innerRadius * Math.sin(angle)
    );
    ctx.lineTo(
      centerX + outerRadius * Math.cos(angle),
      centerY + outerRadius * Math.sin(angle)
    );
    ctx.strokeStyle = 'rgba(0, 255, 148, 0.4)';
    ctx.lineWidth = 2;
    ctx.stroke();
  }
};